<span *ngIf="availableObjectsReady == false" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
<span *ngIf="availableObjectsReady == true" class="bg-light py-2 px-3">
  <small class="text-info">{{ collectionName }}</small>
  <small>{{ pathPipe(path) }}</small>
</span>
